import { Country } from 'utils/constants'

export const DAY_MONTH_YEAR_FORMAT = 'DD MMM YYYY'

export const HIGH = 'HIGH'
export const MEDIUM_HIGH = 'MEDIUM_HIGH'
export const MEDIUM = 'MEDIUM'
export const MEDIUM_LOW = 'MEDIUM_LOW'
export const LOW = 'LOW'

export const ESTIMATED_VALUE = 'estimatedValue'
export const ESTIMATED_RENTAL = 'estimatedRental'
export const VALUE_AND_RANGE = 'valueAndRange'
export const VALUE_BAND = 'valueBand'
export const VALUE = 'value'
export const RENT = 'rent'

export const ESTIMATED_VALUE_FSD_ERROR_MSG = 'Sorry, the CoreLogic Valuation Estimate is not available for this property. The Valuation confidence is too low.'
export const ESTIMATED_RENT_FSD_ERROR_MSG = 'Sorry, the CoreLogic Rental Estimate is not available for this property. The Valuation confidence is too low.'

export const NO_ESTIMATED_VALUE_ERROR_MSG = 'Sorry, the CoreLogic Valuation Estimate is not available for this property.'
export const NO_ESTIMATED_RENT_ERROR_MSG = 'Sorry, the CoreLogic Rental Estimate is not available for this property.'

export const FALLBACK_AVM_DISCLAIMER = 'An automated valuation model estimate (<b>AVM Estimate</b>) is a statistically derived estimate of the sale or rental value (as the context requires) of the subject property. An AVM Estimate is generated (i) by a computer driven mathematical model in reliance on available data; (ii) without the physical inspection of the subject property; (iii) without taking into account market conditions which may, together or separately, affect the value.<br><br/>An AVM Estimate is current only at the date of publication or supply and must not be relied upon as a professional valuation or an accurate representation of the market sale or rental value of the subject property.<br><br/>CoreLogic does not warrant the accuracy, currency or completeness of the AVM Estimate and to the full extent permitted by law, CoreLogic excludes all liability for any loss or damage howsoever arising in connection with an AVM Estimate.'
export const FALLBACK_ESTIMATED_VALUE_DISCLAIMER = 'The Confidence is based on a statistical calculation as to the probability of the Estimated Value being accurate compared to market value. An Estimated Value with a ‘High‘ confidence is considered more reliable than an Estimated Value with a ‘Medium’ or ‘Low’ confidence. The Confidence is a reflection of amount of data we have on the property and similar properties in the surrounding areas. Generally, the more data we have for the local real estate market and subject property, the higher the Confidence level will be.<br><br>Confidence should be considered alongside the Estimated Value.<br><br>Confidence is displayed as a coloured coded range with red representing low confidence, through to amber which represents medium confidence to green for higher confidence'

export const DEFAULT_AVM_DISPLAY_TYPE_BY_COUNTRY = Object.freeze({
  [Country.AU]: VALUE_AND_RANGE,
  [Country.NZ]: VALUE_BAND
})

export const CONFIDENCES = Object.freeze({
  [HIGH]: 'High Confidence',
  [MEDIUM_HIGH]: 'Medium to High Confidence',
  [MEDIUM]: 'Medium Confidence',
  [MEDIUM_LOW]: 'Low to Medium Confidence',
  [LOW]: 'Low Confidence'
})

export const CONFIDENCE_COLORS_BY_TYPE = Object.freeze({
  [VALUE]: Object.freeze({
    [HIGH]: '#39B54A',
    [MEDIUM_HIGH]: '#8ABA14',
    [MEDIUM]: '#EFA000',
    [MEDIUM_LOW]: '#F0763E',
    [LOW]: '#FF0F0F'
  }),
  [RENT]: Object.freeze({
    [HIGH]: '#7ED321',
    [MEDIUM]: '#F3B200',
    [LOW]: '#FF1310'
  })
})

export const CONFIDENCE_GRAPHS = Object.freeze({
  [HIGH]: 'high.png',
  [MEDIUM_HIGH]: 'mid-to-high.png',
  [MEDIUM]: 'mid.png',
  [MEDIUM_LOW]: 'low-to-mid.png',
  [LOW]: 'low.png'
})
